/* ***************************************************************** */
/* TODO: eslint pre-existing exceptions auto generated on 2022-09-08 */
/*       Do not add to these rule exceptions. Only remove as the     */
/*       violations are cleaned from our code.                       */
/*                                                                   */
/*       eslint-disable no-nested-ternary                            */
/* ***************************************************************** */
import React, { useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { IconButton } from '@mui/material';
import FileCopyOutlined from '@mui/icons-material/FileCopyOutlined';
import { trackEvent } from '../../services/analytics-service';

export default function ClipboardContainer(props) {
  const { value, isValueVisible, children } = props;
  const [displayCopied, setDisplayCopied] = useState(false);
  return (
    <>
      <span>{displayCopied ? 'Copied!' : isValueVisible ? value : ''}</span>
      {!displayCopied && (
        <CopyToClipboard title={value} text={value} onCopy={handleCopy}>
          <IconButton
            size="small"
            title="Copy to clipboard"
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
            }}
            disableFocusRipple
            disableRipple
          >
            <FileCopyOutlined />
          </IconButton>
        </CopyToClipboard>
      )}
      {children}
    </>
  );

  function handleCopy(val) {
    setDisplayCopied(true);
    trackEvent({
      name: 'copy_to_clipboard',
      category: 'Utilities',
      label: 'Copy To Clipboard',
      action: 'copy',
      value: val,
    });
    setTimeout(() => setDisplayCopied(false), 500);
  }
}
